export default __webpack_public_path__ + "static/media/buyingRecommendation.16285a23.svg";